import * as React from 'react';
import { Field, Form } from 'formik';
import cx from 'classnames';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';

import PopupTerms from './PopupTerms';
import PopupAgreement from './PopupAgreement';


class LegalForm extends React.Component<any, any> {
  state = {
    showTerms: false,
    showAgreement: false,
  };

  // Validation
  isValidDBAName = (name) => {
    return !!name;
  };

  isValidEIN = (ein) => {
    return !!ein;
  };

  // Terms
  onShowTerms = (e) => {
    e.preventDefault();
    this.setState({ showTerms: true });
  };

  onCloseTerms = (e) => {
    e.preventDefault();
    this.setState({ showTerms: false });
  };

  // Agreement
  onShowAgreement = (e) => {
    e.preventDefault();
    this.setState({ showAgreement: true });
  };

  onCloseAgreement = (e) => {
    e.preventDefault();
    this.setState({ showAgreement: false });
  };

  render() {
    const { initialValues, onSubmit, message } = this.props;
    const { showTerms, showAgreement } = this.state;

    return (
      <div className="sett__view ">
        <h3 className="sett__title">Legal</h3>
        <p className="sett__text">Complete the tasks below to be compliant.</p>
        <FormikForm
          initialValues={initialValues}
          enableReinitialize
          onSubmit={onSubmit}
          render={(props) => {
            const { values, setFieldValue } = props;

            return (
              <React.Fragment>
                <Form>
                  <ol className="list__cont list--steps">
                    <li className="list--steps__item">
                      <label className="input--check">
                        <span
                          className={cx('input--check__circle', { 'checked': this.isValidDBAName(values.dbaName) })} />
                      </label>
                      <Field
                        name="dbaName"
                        label="DBA Name"
                        className="input input--md input--lite"
                        type="text"
                        component={Input} />
                    </li>
                    <li className="list--steps__item">
                      <label className="input--check">
                        <span
                          className={cx('input--check__circle', { 'checked': this.isValidEIN(values.einNumber) })} />
                      </label>
                      <Field
                        name="einNumber"
                        label="Enter EIN Number"
                        className="input input--md input--lite"
                        type="text"
                        component={Input} />
                    </li>
                    {/* Disabled for now
                    <li className="list--steps__item">
                      <label className="input--check">
                        <span className={cx('input--check__circle', { 'checked': values.file })} />
                      </label>
                      
                      <label className="btn btn--lg btn--lite">
                        <input
                          type="file"
                          name="file"
                          className="dn"
                          onChange={(event) => {
                            // TODO: Move me?
                            var reader = new FileReader();

                            reader.readAsDataURL(event.currentTarget.files[0]);

                            reader.onload = function () {
                              setFieldValue('file', reader.result);
                            };

                            reader.onerror = function (error) {
                              console.log('Error: ', error);
                            };
                          }}
                        />
                        Upload File
                      </label>
                      */}
                      {/* TODO: Link to support article 
                      <p className="sett__text">Upload articles of incorporation.
                        <a
                          href="javascript:void(null)"
                          className="sett__anch">What’s this?</a>
                      </p>
                    </li>
                    */}
                    <li className="list--steps__item">
                      {values.acceptedTerms ? (
                        <React.Fragment>
                          <a onClick={this.onShowTerms} href="#" className="btn btn--lg btn--lite">Open</a>
                          <p className="sett__text">Terms of service.</p>
                        </React.Fragment>
                      ): (
                        <React.Fragment>
                          <label className="input--check">
                            <span className={cx('input--check__circle', { 'checked': values.acceptedTerms })} />
                          </label>
                          <a onClick={this.onShowTerms} href="#" className="btn btn--lg btn--lite">Open</a>
                          <p className="sett__text">Accept terms of service.</p>
                        </React.Fragment>
                      )}
                    </li>
                    <li className="list--steps__item">
                      {values.acceptedAgreement ? (
                        <React.Fragment>
                          <a
                        onClick={this.onShowAgreement}
                                href="#"
                                className="btn btn--lg btn--lite">Open</a>
                          <p className="sett__text">Financial agreement</p>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <label className="input--check">
                            <span className={cx('input--check__circle', { 'checked': values.acceptedAgreement })} />
                          </label>
                          <a
                        onClick={this.onShowAgreement}
                                href="#"
                                className="btn btn--lg btn--lite">Open</a>
                          <p className="sett__text">Accept financial agreement.</p>
                        </React.Fragment>
                      )}
                    </li>
                  </ol>

                  {message && <div className="form__note">{message}</div>}

                  <button
                    className="btn btn--lite btn--xlg fw"
                    type="submit">Save Changes
                  </button>
                </Form>
                {showTerms && (
                  <PopupTerms
                    onClose={this.onCloseTerms} isSelected={values.acceptedTerms}
                    onChange={(e) => setFieldValue('acceptedTerms', e.target.checked ? new Date() : '')}
                    initialSelected={initialValues.acceptedTerms} />
                )}
                {showAgreement && (
                  <PopupAgreement
                    onClose={this.onCloseAgreement} isSelected={values.acceptedAgreement}
                    onChange={(e) => setFieldValue('acceptedAgreement', e.target.checked ? new Date() : '')}
                    initialSelected={initialValues.acceptedAgreement} />
                )}
              </React.Fragment>
            );
          }}
        />
      </div>
    );
  };
}

export default LegalForm;
